import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from "react-router-dom";
import './About.css';
import pkg from '../../package.json';


const About = () => {
	const { t } = useTranslation();
	const { i18n } = useTranslation();
    const { lang } = useParams();

	useEffect(() => {
		if(!lang) return; // если язык не установили по УРЛ, то не меняем его
		if(lang === 'en') {
			i18n.changeLanguage('en')
		} else {
			i18n.changeLanguage('ru')
		}
	}, [ lang, i18n ]);

	return (
		<div className='About'>
	    	<h1>{t('about.title')}</h1>
            <div
                dangerouslySetInnerHTML={
                    {__html: t('about.about', { 'interpolation': {'escapeValue': false} })}
                }
            />
			<div className='p'>
				Version: {pkg.version}
			</div>
		</div>
	);
};

export default About;
